import React from "react";
import { Minus, Plus } from "lucide-react";

interface BookCardProps {
  book: BookNew;
  selectedBooks: { bookId: string; quantity: number }[];
  handleQuantityChange: (bookId: string, quantity: number) => void;
  userClient: Client | undefined;
}

const BookCard: React.FC<BookCardProps> = ({
  book,
  selectedBooks,
  handleQuantityChange,
  userClient,
}) => {
  const basePrice = book.price!;
  let finalPrice = basePrice;
  const clientDiscounts = userClient?.discounts || [];

  // obliczenie ceny po zniżkach
  clientDiscounts.forEach((discount) => {
    finalPrice -= (basePrice * discount.valuePercent) / 100;
  });

  const currentQty =
    selectedBooks.find((b) => b.bookId === book.id)?.quantity || 0;

  const isTeachersBook = book.bookNum.toString().length === 2;
  const num = isTeachersBook ? String(book.bookNum)[0] : book.bookNum;
  const imageSrc = isTeachersBook
    ? require(`../assets/Book-${num}T.jpg`)
    : require(`../assets/Book-${num}.jpg`);

  return (
    <div className="flex h-full flex-col md:bg-white/40 md:shadow-sm md:rounded-[28px] md:p-4">
      <img
        src={imageSrc}
        alt={`Książka ${num}`}
        className="rounded-[22px] object-contain"
      />

      <div className="mt-4 flex-1 text-center">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.26em] text-slate-500">
          {isTeachersBook ? "Teacher's Book" : "Student's Book"}
        </p>

        <span className="mt-2 min-h-[3.5rem] text-sm font-semibold leading-6 text-slate-900">
          English Unlocked {num}{" "}
        </span>
      </div>

      <div className="mt-2 rounded-[22px] border border-white px-4 py-3 text-center shadow-[0_10px_24px_rgba(148,163,184,0.17)] backdrop-blur-lg">
        {finalPrice !== basePrice ? (
          <>
            <span className="block text-sm font-semibold text-slate-400 line-through">
              {basePrice?.toFixed(2)} PLN
            </span>
            <span className="mt-1 block text-base font-semibold text-rose-500">
              {finalPrice?.toFixed(2)} PLN
            </span>
          </>
        ) : (
          <span className="block text-base font-semibold text-slate-800">
            {finalPrice?.toFixed(2)} PLN
          </span>
        )}
      </div>

      <div className="mt-2 flex items-center rounded-full border border-white/80 p-2 shadow-[0_10px_24px_rgba(148,163,184,0.17)] backdrop-blur-lg">
        <button
          type="button"
          onClick={() =>
            handleQuantityChange(book.id, Math.max(0, currentQty - 1))
          }
          className="flex items-center justify-center text-black/60 "
        >
          <Minus size={26} />
        </button>
        <input
          type="number"
          min="0"
          value={currentQty}
          onChange={(e) =>
            handleQuantityChange(book.id, parseInt(e.target.value) || 0)
          }
          className=" w-full bg-transparent text-center text-xl font-semibold text-slate-700 outline-none no-spinner"
        />
        <button
          type="button"
          onClick={() => handleQuantityChange(book.id, currentQty + 1)}
          className="flex items-center justify-center  text-black/60"
        >
          <Plus size={26} />
        </button>
      </div>
    </div>
  );
};

export default BookCard;
